import { useEffect } from 'react';

import { VIEWS } from '../constants';

// Cale l'en-tête (jours/mois) sur le scroll horizontal du corps à chaque frame plutôt que sur
// l'event "scroll" : pendant un scroll au trackpad/molette, le corps défile via le compositor du
// navigateur à pleine fréquence, alors que l'event "scroll" est coalescé/throttlé par le
// navigateur (surtout en scroll inertiel) — un onScroll classique fait donc "traîner" l'en-tête
// d'une vitesse visiblement différente de celle du corps. En relisant scrollLeft à chaque
// requestAnimationFrame (donc juste avant chaque peinture), l'en-tête reste au même rythme que
// le corps quel que soit le débit des events "scroll".
export function useTimelineHeaderScrollSync({
  appState,
  timelineBodyScrollRef,
  timelineHeaderGridRef,
}) {
  useEffect(() => {
    if (appState.view !== VIEWS.TIMELINE) return;
    let raf,
      lastSL = null;
    const tick = () => {
      const body = timelineBodyScrollRef.current,
        grid = timelineHeaderGridRef.current;
      if (body && grid) {
        const sl = body.scrollLeft;
        if (sl !== lastSL) {
          grid.style.transform = `translateX(${-sl}px)`;
          lastSL = sl;
        }
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [appState.view]);
}
